import { Button } from "@material-ui/core";
import React, { useState,useEffect } from "react";
import StudentSidebar from "../../../common/Sidebar/StudentSideBar";
import "./StudentVideos.css"; 
function StudentVideos() {
  const [allVideo, setAllVideo] = useState(true);
  // const [isLive, setLive] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  // const [data, setData] = useState("");
  const [educators,setEdu] = useState([]);
  const [videoData, setVideoData] = useState([]);

  // async function getVideos(){

  // }

  useEffect(()=>{
    var v = [];
    console.log('In use Effect');  
    const u=JSON.parse(localStorage.getItem('user'));
    setEdu(u.educator_assigned);
    for(var i=0;i<educators.length;i++){
      console.log(educators[i]['email']);
      fetch("https://edtechv.herokuapp.com/api/get_video",{
        method: "post",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({
            email: educators[i]['email'],
        })
      })
    .then((response)=>response.json())
    .then((videos)=>{
        console.log(videos);
        v.push(videos);
    })
    }
    console.log(videoData)
    setVideoData(v);
},[]); 
  

  var videos= [
    {
      thumbnail:"https://firebasestorage.googleapis.com/v0/b/shrink4shrink.appspot.com/o/1.%20What%20You'll%20Need.mp4?alt=media&token=a3094c91-10f8-4ea6-b68d-898564c3f7bc",
      title: "Flutter Intro",
      description: "Flutter",
      subject:"Web Dev",
      time: "12:00 pm 12-01-2022"
    },
    {
      thumbnail: "https://firebasestorage.googleapis.com/v0/b/mobial.appspot.com/o/2.%20Running%20our%20Project.mp4?alt=media&token=e4bd22d5-5d58-459c-8f35-9f519947718c",
      title: "Flutter Code Run",
      description: "Flutter",
      subject: "Web Dev",
      time: "1:00 pm 13-01-2022"
    }
  ];
  
  const AllVideos = () => {
    return (
      <div className="all-videos-t" style={{height:"100vh"}}>
        <div className="teach-daily-videos">
          {
            videos.map((ele)=>{ 
            return(
              <div className='daily-videos'  style={{backgroundColor:"#E9F2FF",margin:"20px", padding:"15px"}}>
                <video width="400" controls="controls" preload="metadata">
                <source src={ele.thumbnail} type="video/mp4"/>
              </video>
                <div>
                    <div className='daily-videos-l'>
                    <h2>{ele.title}</h2>
                    <p>{ele.description}</p>
                    <p>{ele.subject}</p>
                    </div>
                    <div>
                        <p>{ele.time}</p>
                    </div>
                </div>
            </div>
            )
            })
          }
        </div>
        
      </div>
    );
  };
  // const AddVideos=()=>{
  //   return (
  //     <div>
  //       <TextField/>
  //     </div>
  //   )
  // }
  return (
    <div className="educator-videos">
      <StudentSidebar />
      <div className="teach-vid-main">
        <h1>Your Videos</h1>
        <Button
          onClick={() => setAllVideo(true)}
          style={{
            backgroundColor: `${
              allVideo ? "rgb(223, 240, 246)" : "rgb(234, 230, 230)"
            }`,
          }}
        >
          All Videos
        </Button>
        <AllVideos />
      </div>
    </div>
  );
}

export default StudentVideos;
